<template>
  <section class="sec-footer">
    <QACON data-anchor="QACON" :qa-list="qaList" />
    <COOPERATE :cooperate-img="cooperateImg" />
    <EXPLAIN :explain-desc="explainDesc" />
  </section>
</template>
<script>
import QACON from '../footer/qa.vue'
import COOPERATE from '../footer/cooperate.vue'
import EXPLAIN from '../footer/explain.vue'

export default {
  components: {
    QACON,
    COOPERATE,
    EXPLAIN,
  },
  data() {
    return {}
  },
  props: {
    qaList: {
      type: Array,
      default: () => {},
      required: true,
    },
    cooperateImg: {
      type: String,
      default: () => '',
    },
    explainDesc: {
      type: String,
      default: () => '',
    },
  },
  methods: {},
}
</script>
<style lang="less">
.sec-footer {
  font-family: HYYakuHei55W;
  width: 100%;
  overflow: hidden;
}
</style>
